(function ($, Drupal) {

  /**
   * Move the care home search form into the mobile menu when it shows.
   * Expanding search form when clicked in mobile view, as fields are initially
   * hidden.
   */
  Drupal.behaviors.mobileSearch = {

    attach: function (context, settings) {

      once('mobileSearch', '.mobile-search', context).forEach(function (element, index) {

        const formId = '.block-views-exposed-filter-blockcare-home-finder-tool-for-header-block-1';
        const fieldsToHideWhenClosed = [
          'input[name="field_location_proximity_center[geocoder][geolocation_geocoder_address]"]',
          '#edit-submit-care-home-finder-tool-for-header',
        ];
        const searchFieldLabelSelector = '.form-item-field-location-proximity-center-geocoder-geolocation-geocoder-address label';
        const searchForm = document.querySelector(formId);
        let labelIcon;

        // Keep track of whether mobile search is expanded.
        // Initially it just shows the label of the search field and an icon.
        let mobileSearchFormOpen = false;

        // When the mobile view is shown, move the care home search form to the mobile
        // search area.
        // This avoids having two versions of the same form on a page,
        // which the geolocation module can't seem to handle.
        const observer = new IntersectionObserver((elems, obs) => {
          if(elems[0].intersectionRatio == 0) {
            moveSearchForm('.desktop-search');
          }
          else {
            moveSearchForm('.mobile-search');

          }
        });
        observer.observe(element);

        // Click label to expand mobile search form.
        context.querySelector(searchFieldLabelSelector)
          .addEventListener('click', function() {
            expandMobileSearch();
          });

        /**
         * Moves the search form between desktop and mobile areas.
         *
         * @param classOfContainer string
         *  ID of container class to move to.
         */
        function moveSearchForm(classOfContainer) {
          const container = document.querySelector(classOfContainer);
          // If container already contains the form, then do nothing.
          if (!container.querySelector(formId)) {
            // Clear both containers just in case.
            document.querySelector('.mobile-search').replaceChildren();
            document.querySelector('.desktop-search').replaceChildren();
            // Put the form into the destination container.
            container.append(searchForm);
            // Hide parts of form in collapsed mobile version.
            switchFormView(classOfContainer !== '.mobile-search')
          }
        }

        /**
         * Show all items in the mobile search form.
         */
        function expandMobileSearch() {
          switchFormView(
            true
          );
          mobileSearchFormOpen = true;
          context.querySelector(searchFieldLabelSelector).style.display = 'none';
        }

        /**
         * Show and hide elements if necessary when form switches between
         * desktop and mobile.
         *
         * @param desktop boolean
         */
        function switchFormView(desktop) {
          if (mobileSearchFormOpen) {
            // Once it's open, it stays open.
            return;
          }
          if (desktop) {
            // Showing form in desktop view.
            fieldsToHideWhenClosed.forEach(fieldSelector => {
              searchForm.querySelector(fieldSelector).style.display = '';
            });
            // Hide magnifying glass icon - used on mobile only.
            labelIcon.style.display = 'none';
          }
          else {
            // Showing form in mobile view.
            fieldsToHideWhenClosed.forEach(fieldSelector => {
              searchForm.querySelector(fieldSelector).style.display = 'none';
            });
            if (!labelIcon) {
              addIconToMobileSearchForm();
            }
            labelIcon.style.display = '';
          }
        }

        /**
         * Add magnifying glass icon to search for label.
         */
        function addIconToMobileSearchForm() {
          labelIcon = document.createElement('img');
          labelIcon.setAttribute('src', '/themes/sierra/assets/icons/svg/search-navy.svg');
          context.querySelector(searchFieldLabelSelector).prepend(labelIcon);
        }

      });

    }

  };

})(jQuery, Drupal);
